export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";

export const USER_LOGOUT_SUCESS = "USER_LOGOUT_SUCCESS";

export const USER_GOOGLE_LOGIN = "USER_GOOGLE_LOGIN";
